<template>
  <div class="columns">
    <div class="column">
      <div class="box">
        <a class="anchor" name="scores"></a>
        <h3>Scores</h3>
        <hr />
        <div class="block">
          <p><b>Slider Preview</b></p>
          <b-field>
            <b-slider
              :min="1"
              :max="questionDescriptions.length"
              :tooltip="false"
              size="is-medium"
            >
              <template v-for="(score, index) in questionDescriptions">
                <b-slider-tick :value="index + 1" :key="index + 1">{{
                  index + 1
                }}</b-slider-tick>
              </template>
            </b-slider>
          </b-field>
        </div>
        <div class="block">
          <p><b>Radio Preview</b></p>
          <b-field>
            <div class="question-radio">
              <draggable
                v-model="questionDescriptions"
                group="people"
                @start="drag = true"
                @end="drag = false"
              >
                <div
                  v-for="(score, index) in questionDescriptions"
                  :key="index"
                >
                  <div v-if="edit" class="is-flex edit-score-container">
                    <span
                      style="
                        display: inline-block;
                        padding-bottom: 15px;
                        padding-right: 10px;
                      "
                      >{{ index + 1 }}.
                    </span>
                    <b-input :value="score.name" v-model="score.name"></b-input>
                    <div class="icon-container" @click="removeScore(index)">
                      <b-icon
                        pack="fas"
                        icon="trash"
                        type="is-danger"
                        size="is-small"
                      ></b-icon>
                    </div>
                  </div>
                  <b-radio v-else name="slider-radio" native-value="default">
                    {{ index + 1 }} - {{ score.name }}
                  </b-radio>
                </div>
              </draggable>
            </div>
          </b-field>
          <b-button type="is-primary" outlined @click="addScore()"
            >Add Score</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// https://github.com/SortableJS/Vue.Draggable
import Draggable from 'vuedraggable';

export default {
  components: {
    Draggable,
  },
  props: {
    value: { type: Array },
  },
  data() {
    return {
      questionDescriptions: this.value,
      edit: true,
    };
  },
  methods: {
    addScore: function () {
      this.questionDescriptions.push({
        id: this.questionDescriptions.length + 1,
        name: '',
        order: this.questionDescriptions.length + 1,
      });
    },
    removeScore: function (index) {
      this.questionDescriptions.splice(index, 1);
    },
  },
  watch: {
    questionDescriptions: function () {
      this.$emit('input', this.questionDescriptions);
    },
  },
};
</script>
